import { render, staticRenderFns } from "./ListaTecnicosUnidade.vue?vue&type=template&id=af8b10b6&scoped=true"
import script from "./ListaTecnicosUnidade.vue?vue&type=script&lang=js"
export * from "./ListaTecnicosUnidade.vue?vue&type=script&lang=js"
import style0 from "./ListaTecnicosUnidade.vue?vue&type=style&index=0&id=af8b10b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8b10b6",
  null
  
)

export default component.exports